module.exports = __webpack_public_path__ + "img/Logotype-fa.829b858f.png";